import React from "react";
import styled from "styled-components";

const Wrapper = styled.div<any>`
    display: flex;
    flex-flow: column;
    /* justify-content: center; */
    align-items: center;
    width: 233px;
    min-width: 233px;
    height: 267px;
    min-height: 267px;
    padding: 24px 14px;
    box-sizing: border-box;
    box-shadow: 0px 0px 0px 1px #e4e7ee;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    ${({isActive}) => isActive && `
        border: 2px solid #618AEE;
    `}
`;

const Title = styled.div`
    font-size: ${({ theme }) => theme.fontSize.big};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-bottom: 8px;
`;

const Description = styled.div`
    height: 60px;
    width: 170px;
    text-align: center;
    color: ${({ theme }) => theme.colors.secondaryBlack};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
    white-space: pre-wrap;
`;

const Image = styled.div`
    min-height: 68px;
    min-width: 68px;
    border-radius: 4px;
    background: #CCD9FA;
    margin-bottom: 24px;
`;

export const ChannelBox = ({data, onClick, isActive} : any) => {
    return (
        <Wrapper isActive={isActive} onClick={onClick}>
            <Image>image</Image>
            <Title>{data.title}</Title>
            <Description>{data.description}</Description>
        </Wrapper>
    )
}